/**
 * Formats a number or string into a currency format (e.g., 1,234,567)
 * @param value - The value to format
 * @returns Formatted string
 */
export const formatCurrency = (value: string | number): string => {
    if (!value) return "0";
    const num = Number(value);
    return num.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };